import React from 'react';

export const BlogWriterHeader: React.FC = () => {
  return (
    <div className="bg-background-main rounded-lg p-6 text-text-primary">
      <h1 className="text-2xl font-semibold mb-2">Blog Writer</h1>
      <p className="text-sm opacity-90">
        Discover a free AI blog writer tool that creates engaging and
        well-written articles effortlessly. Boost your content creation process
        and quality today!
      </p>
    </div>
  );
};
